import React from 'react';
import Timer from 'react-compound-timer';
import styled from 'styled-components'
const Timmer = ({ time, timerFlag, callBackTimmer }) => {
    if (timerFlag === undefined) {
        timerFlag = true
    }
    return (
        <Timer
            initialTime={time * 1000}
            direction="backward"
            startImmediately={timerFlag}
            lastUnit="h"
            checkpoints={[
                {
                    time: 0,
                    callback: () => {
                        callBackTimmer()
                    },
                },
            ]}
        >
            {({ start, resume, pause, stop, reset, timerState }) => (
                <React.Fragment>
                    <div>
                        <Timer.Hours formatValue={(value) => `${(value < 10 ? `0${value}` : value)}`} />:
                        <Timer.Minutes formatValue={(value) => `${(value < 10 ? `0${value}` : value)}`} />:
                        <Timer.Seconds formatValue={(value) => `${(value < 10 ? `0${value}` : value)}`} />
                    </div>
                </React.Fragment>
            )}
        </Timer>
    )
}

export default Timmer;


const TimerWrapper = styled.div`
    display: flex;
`
const TimerBox = styled.div`
 display: flex;
 flex-direction: column;
 align-items: center;
`
const TimerUnit = styled.div`
    width: 100%;
    text-align: center;
    background: #d8d8d8;
    font-size: 26px;
    width: 58px;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
`